<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-forward-all`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 41a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zm0-8a1 1 0 011 1v2a1 1 0 01-1 1H17a1 1 0 01-1-1v-2a1 1 0 011-1h26zM25.238 2.232a.828.828 0 011.057-.077l.091.077L39.643 15.16c.444.433.474 1.117.089 1.584l-.089.096-13.257 12.928a.822.822 0 01-.574.232.805.805 0 01-.806-.693L25 29.208v-7.332h-1.586c-6.156 0-10.82 2.028-13.65 5.677a14.31 14.31 0 00-.694 1.002.5.5 0 01-.917-.21C8.05 27.491 8 26.8 8 26.272c0-9.43 7.437-17.095 16.677-17.27L25 9V2.792c0-.21.086-.412.238-.56zM29 10.368V13h-4c-4.828 0-9.272 2.709-11.294 7.005a24.746 24.746 0 019.141-1.984l.567-.007H29v3.618L34.775 16 29 10.368z"/></svg>
</template>
<script>

export default {
  name: 'IconForwardAll',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
